module.exports = __webpack_public_path__ + "static/media/pay-option-ticked.c0f33568.svg";